import Styles from './PostPreviewModal.module.scss'
import { ScheduledPostShow } from 'api/clients/ScheduledPostsClient'
import { useExternalIntegrations } from 'components/ExportModal/ExternalIntegrations/ExternalIntegrations'
import { useUpdateScheduledPost } from 'hooks/queries/scheduledPosts/useUpdateScheduledPost'
import { ExternalIntegrationSelect } from 'components/ExternalIntegrationSelect/ExternalIntegrationSelect'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { Text } from 'blaze-ui/Text/Text'

interface Props {
  scheduledPost: ScheduledPostShow
  provider: ExternalIntegrationEnum
  providerName: string
}

export const IntegrationPicker = ({ scheduledPost, providerName, provider }: Props) => {
  const integrationsQuery = useExternalIntegrations()
  const updateScheduledPost = useUpdateScheduledPost({ suppressToast: true })

  const selectedIntegrationId = scheduledPost.external_integration?.id
  const integrations = integrationsQuery.data?.external_integrations.filter((i) => i.provider === provider)

  if (!integrations || !selectedIntegrationId) return null

  const handleIntegrationSelect = (externalIntegrationId: number) => {
    updateScheduledPost.mutate({ id: scheduledPost.id, params: { externalIntegrationId } })
  }

  return (
    <div className={Styles.section}>
      <Text variant="label" color="var(--dark-60)">
        {providerName} Account
      </Text>
      <div className={Styles.integrationPicker}>
        <ExternalIntegrationSelect
          onChange={handleIntegrationSelect}
          selectedExternalIntegrationId={selectedIntegrationId}
          externalIntegrations={integrations}
          forceProvider={provider}
          useFullWidth
          useButtonWidth
          showName
          itemClassName={Styles.integrationItem}
          labelClassName={Styles.integrationItemLabel}
        />
      </div>
    </div>
  )
}
